'use strict';
import React from 'react';
import NavBar from './navBar';
import SideMenu from './sideMenu';
import JPHeader from './jpComponents/jpHeader';
import JPBody from './jpComponents/jpBody';
import jpAction from '../actions/jpAction';
import jpStore from '../stores/jpStore';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import userStore from '../stores/userStore';
import menuAction from '../actions/menuAction';
import Loading from './loading';
import genFunction from '../functions/genFunction';
import JPconfirmModal from './jpComponents/jpConfirmModal';

class JourneyPlanner extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.hasStatus = this.hasStatus.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.callBack = this.callBack.bind(this);
        this.handleClaimSubmit = this.handleClaimSubmit.bind(this);
        this.state = {
            staffs: filterStore.getState().staffs,
            processingFilter: filterStore.getState().processing,
            iniLoadStaff: filterStore.getState().iniLoadStaff,
            selectedYear: jpStore.getState().selectedYear,
            selectedMonth: jpStore.getState().selectedMonth,
            journeyList: jpStore.getState().journeyList,
            staffId: jpStore.getState().staffId,
            processing: jpStore.getState().processing,
            submitRecord: jpStore.getState().submitRecord,
            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,

            modalClose: false,
            action: 0,
            title: "",
        };
    }

    componentDidMount() {
        jpStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
        filterStore.listen(this.onFilterChange);
        menuAction.pageNumber(2);
        jpAction.warningMsg("");

        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            filterAction.processing(true);
            filterAction.getEmployee();
        }
    }
    componentWillUnmount() {
        jpStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
        filterStore.unlisten(this.onFilterChange);
    }
    onFilterChange(state) {
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
        });
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        });
    }
    onChange(state) {
        this.setState({
            journeyList: state.journeyList,
            selectedYear: state.selectedYear,
            selectedMonth: state.selectedMonth,
            processing: state.processing,
            staffId: state.staffId,
            submitRecord: state.submitRecord,
        });
    }
    hasStatus(status) {
        let hasStatus = false;
        let len = this.state.journeyList.length;
        if (status == 1 || status == 2 || status == 3) {
            for (let i = 0; i < len; i++) {
                if (status == this.state.journeyList[i].status) {
                    hasStatus = true;
                    break;
                }
            }
        } else {
            hasStatus = true;
            for (let i = 0; i < len; i++) {
                if (this.state.journeyList[i].status == 1 || this.state.journeyList[i].status == 2 ||
                    this.state.journeyList[i].status == 3) {
                    hasStatus = false;
                    break;
                }
            }
        }
        return hasStatus;
    }
    handleClick(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (this.state.staffId == -1) {
            return jpAction.warningMsg("Please Select Staff Name");
        }
        if (this.state.processing) return;

        let title;
        //prompt user first b4 confirm
        if (index == 0) {
            //check if status has 0
            if (!this.hasStatus(1)) {
                return jpAction.warningMsg("Claims do no need justification");
            } else {
                jpAction.warningMsg("");
                title = "Mileage Claim Justification";
            }
        } else if (index == 1) {
            if (!this.hasStatus(0)) {
                return jpAction.warningMsg("Please make sure all claims are approved");
            } else {
                jpAction.warningMsg("");
                title = "Mileage Claim Submission";
            }
        } else if (index == 2) {
            if (!this.hasStatus(2)) {
                return jpAction.warningMsg("No rejected claim");
            } else {
                jpAction.warningMsg("");
                title = "Mileage Claim Reject";
            }
        }
        this.setState({
            action: index,
            title: title,
            modalClose: true
        });
    }
    handleClaimSubmit() {
        jpAction.claimSubmit(this.state.selectedYear, this.state.selectedMonth);
    }
    shouldModalClose(data) {
        this.setState({ modalClose: data });
    }
    callBack(action) {
        jpAction.processing(true);
        jpAction.warningMsg("");

        if (action == 0) {
            jpAction.emailJustification(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
        } else if (action == 1) {
            jpAction.emailApproved(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
        } else {
            jpAction.emailReject(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
        }
        //reset data
        this.setState({
            modalClose: false,
            action: 0,
            title: ""
        });
    }
    hasSubmit(reminder){
        let hasSubmit = false;
        for(let i = 0 ; i < this.state.submitRecord.length ; i++){
            if(reminder == this.state.submitRecord[i].reminder){
                hasSubmit = true;
                break;
            }
        }

        return hasSubmit;
    }
    render() {
        let adminBtn = "";
        if (genFunction.hasPermission(this.state.permission, 1)) {
            adminBtn = (
                <div className="jp-btn-grp">
                    {this.state.userId == this.state.staffId &&
                        <button className={"btn btn-default " +(this.hasSubmit(0)?"btn-grey":"")} 
                            data-index="3" onClick={this.handleClaimSubmit}>Submit Claim</button>
                    }
                    <button className={"btn btn-default " +(this.hasSubmit(1)?"btn-grey":"")} 
                        data-index="0" onClick={this.handleClick}>Email to Employee for Justification</button>
                    <button className={"btn btn-default " +(this.hasSubmit(2)?"btn-grey":"")} 
                        data-index="1" onClick={this.handleClick}>Journey Claim Approved</button>
                    <button className={"btn btn-default " +(this.hasSubmit(3)?"btn-grey":"")} 
                        data-index="2" onClick={this.handleClick}>Journey Claim Denied</button>

                </div>
            );
        } else if (this.state.userId == this.state.staffId) {
            adminBtn = (
                <div className="jp-btn-grp">
                    <button className="btn btn-default" data-index="3" onClick={this.handleClaimSubmit}>Submit Claim</button>
                </div>
            );
        }

        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 atd">
                        <JPHeader staffs={this.state.staffs} iniLoad={this.state.iniLoad} />
                        <div className="divider"></div>
                        <JPBody journeyList={this.state.journeyList} {...this.props} />
                        {adminBtn}
                    </div>
                </div>
                <JPconfirmModal
                    modalClose={this.state.modalClose}
                    action={this.state.action}
                    callBack={this.callBack}
                    title={this.state.title}
                    shouldModalClose={this.shouldModalClose}
                />
                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div>
        );
    }
}
export default JourneyPlanner;


// WEBPACK FOOTER //
// ./app/components/journeyPlanner.js